import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material';
import React from 'react';

import { useUploadModal } from '../../UploadModalContext';

const SampleTable: React.FC = () => {
  const theme = useTheme();
  const { profile } = useUploadModal();
  const { fileHeaders } = profile;

  // returns a table header where the first cell is empty and the remaining cells are labeled alphabetically (A, B, C, D, ...).
  const tableHeaders = React.useMemo(() => {
    return (
      <TableRow>
        <TableCell>&nbsp;</TableCell>
        {Array.from({ length: fileHeaders.length }, (_, i) => (
          <TableCell key={i} sx={{ opacity: 0.6 }}>
            {String.fromCharCode(i + 65)}
          </TableCell>
        ))}
      </TableRow>
    );
  }, [fileHeaders]);

  // returns a table row where the first cell is 1 and the remaining cells are the required CSV file headers.
  const tableRow = React.useMemo(() => {
    return (
      <TableRow>
        <TableCell sx={{ opacity: 0.6 }}>1</TableCell>
        {fileHeaders.map((header, index) => (
          <TableCell key={index} sx={{ fontWeight: theme.typography.fontWeightMedium }}>
            {header}
          </TableCell>
        ))}
      </TableRow>
    );
  }, [fileHeaders]);

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: 'fit-content',
        maxWidth: '100%',
        display: 'inline-block',
        borderRadius: 0,
        overflowX: 'auto',
        boxShadow: 'none',
        background: theme.sass.tableBgTranslucentColor,
        '&::-webkit-scrollbar': { height: '6px' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0, 0, 0, 0.2)', borderRadius: '3px' },
        '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
      }}
    >
      <Table
        sx={{
          width: 'auto',
          tableLayout: 'auto',
          '& .MuiTableCell-root': {
            fontSize: 10,
            px: 0.9,
            py: 0.5,
            whiteSpace: 'nowrap',
            border: '1px solid',
            borderColor: 'divider',
            lineHeight: 1.3,
          },
          '& .MuiTableHead-root .MuiTableCell-root': {
            textAlign: 'center',
            height: 'auto',
          },
        }}
        aria-label="simple table"
      >
        <TableHead>{tableHeaders}</TableHead>
        <TableBody>{tableRow}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default SampleTable;
